import React from "react";
import { Box, Typography } from "@mui/material";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import HyroFeedbackMessage from "@hyro-components/HyroFeedbackMessage";
import useUtteranceOrder from "./UtteranceOrder.hook";
import { HyroButton } from "@hyro-components";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "@hyro-components/hyro-button/HyroButton.consts";

const SortableItem = ({ id, name }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      sx={{
        p: 2,
        mb: 1,
        borderRadius: 1,
        boxShadow: 3,
        bgcolor: "background.paper",
        cursor: "grab",
        opacity: isDragging ? 0.5 : 1,
        transform: CSS.Transform.toString(transform),
        transition
      }}
    >
      {name}
    </Box>
  );
};

const UtteranceOrder = () => {
  const {
    sortedUtterences,
    handleDragEnd,
    handleUpdateUtteranceOrder,
    feedbackConfig,
    setFeedbackConfig,
    isPending,
    isSaveChangesDisabled
  } = useUtteranceOrder();

  return (
    <>
      <Typography variant="p" mb={2}>Order voice essentials utterances</Typography>

      <Box display="flex" justifyContent="flex-end" mb={4}>
        <HyroButton
          loading={isPending}
          variant={BUTTON_VARIANTS.CONTAINED}
          color={BUTTON_COLORS.PRIMARY}
          onClick={handleUpdateUtteranceOrder}
          disabled={isSaveChangesDisabled}
        >
          Save Changes
        </HyroButton>
      </Box>

      <HyroFeedbackMessage
        message={feedbackConfig.message}
        severity={feedbackConfig.severity}
        showFeedback={feedbackConfig.show}
        closeFeedback={() => setFeedbackConfig(f => ({ ...f, show: false }))}
      />

      <DndContext collisionDetection={closestCenter} onDragEnd={e => handleDragEnd(e, arrayMove)}>
        <SortableContext items={sortedUtterences.map(item => item.specKey)} strategy={verticalListSortingStrategy}>
          {sortedUtterences.map((item) => (
            <SortableItem key={item.specKey} id={item.specKey} name={item.displayName} />
          ))}
        </SortableContext>
      </DndContext>
    </>
  );
};

export default UtteranceOrder;
